import { apiCall, secondaryApi } from './ApiUtils'
import { parseTheme, THEME_DEFAULT } from './common'

export const getNotificationsBySite = (token, siteId, lastEvalKey = null) => apiCall(`notifications/${siteId}/${lastEvalKey ? "?lastEvalKey="+ JSON.stringify(lastEvalKey) : ""}`, {
    method: 'GET'
}, token, secondaryApi)

export const getNotificationsByRange = (siteId, startDate, endDate) => apiCall(`notifications/${siteId}/range/${startDate}/${endDate}`, {
    method: 'GET'
}, null, secondaryApi)

export const markNotificationAsRead = (token, notificationId) => apiCall(`notifications/${notificationId}/markasread`, {
    method: 'PUT'
}, token, secondaryApi)

export const setNotificationStatus = (notificationId, status) => apiCall(`notifications/${notificationId}/status`, {
    method: 'PUT',
    body: {
        status
    }
}, null, secondaryApi)


const alerts = [{
        isNegative: true,
        comparisonType: "custom",
        title: "Google Analytics Not Tracking",
        altTitle: `Google Analytics`,
        overrideTitle: true,
        icon: `${THEME_DEFAULT.origin}/images/alert-icons/urgent.png`,
        value: "",
        operator: "-",
        comparison: "stopped tracking metrics",
        description: `<p>Google Analytics could have stopped tracking for several reasons</p>
        <ul>
            <li>Token is expired or other credential issues which affects platform connectivity</li>
            <li>Google Analytics could have been removed from your site</li>
            <li>The site could be down</li>
            <li>There could be billing or domain registration expiration issues</li>
        </ul>`
    }, {
        isNegative: true,
        comparisonType: "custom",
        title: "Facebook Ads Not Tracking",
        altTitle: `Facebook Ads`,
        overrideTitle: true,
        icon: `${THEME_DEFAULT.origin}/images/alert-icons/urgent.png`,
        value: "",
        operator: "-",
        comparison: "stopped tracking metrics",
        description: `<p>Facebook Ads could have stopped tracking for several reasons</p>
        <ul>
            <li>Token is expired or other credential issues which affects platform connectivity</li>
            <li>You may not be running Facebook Ads currently. Check <a href="https://business.facebook.com/adsmanager" target="_blank">FB Ads Manager</a> if there are ads present</li>
        </ul>`
    }, {
        isNegative: true,
        comparisonType: "custom",
        title: "Google Business Profile Not Tracking",
        altTitle: `Google Business Profile`,
        overrideTitle: true,
        icon: `${THEME_DEFAULT.origin}/images/alert-icons/urgent.png`,
        value: "",
        operator: "-",
        comparison: "stopped tracking metrics",
        description: `<p>Google Business Profile could have stopped tracking for several reasons</p>
        <ul>
            <li>Token is expired or other credential issues which affects platform connectivity</li>
            <li>Verification status for this site could have failed. Check <a href="https://support.google.com/business/answer/7107242?hl=en" target="_blank">here</a> for more information</li>
        </ul>`
    }, {
        isNegative: true,
        comparisonType: "custom",
        title: "Facebook Insights Not Tracking",
        altTitle: `Facebook Insights`,
        overrideTitle: true,
        icon: `${THEME_DEFAULT.origin}/images/alert-icons/urgent.png`,
        value: "",
        operator: "-",
        comparison: "stopped tracking metrics",
        description: `<p>Facebook Insights could have stopped tracking for several reasons</p>
        <ul>
            <li>Token is expired or other credential issues which affects platform connectivity</li>
        </ul>`
    }, {
        isNegative: true,
        comparisonType: "custom",
        title: "Microsoft Ads Not Tracking",
        altTitle: `Microsoft Ads`,
        overrideTitle: true,
        icon: `${THEME_DEFAULT.origin}/images/alert-icons/urgent.png`,
        value: "",
        operator: "-",
        comparison: "stopped tracking metrics",
        description: `<p>Microsoft Ads could have stopped tracking for several reasons</p>
        <ul>
            <li>Token is expired or other credential issues which affects platform connectivity</li>
            <li>You may not be running Microsoft Ads currently. Check <a href="https://ads.microsoft.com/" target="_blank">Microsoft Advertising</a> if there are ads present</li>
        </ul>`
    }, {
        isNegative: true,
        comparisonType: "custom",
        title: "LinkedIn Ads Not Tracking",
        altTitle: `LinkedIn Ads`,
        overrideTitle: true,
        icon: `${THEME_DEFAULT.origin}/images/alert-icons/urgent.png`,
        value: "",
        operator: "-",
        comparison: "stopped tracking metrics",
        description: `<p>LinkedIn Ads could have stopped tracking for several reasons</p>
        <ul>
            <li>Token is expired or other credential issues which affects platform connectivity</li>
            <li>You may not be running LinkedIn Ads currently. Check <a href="https://www.linkedin.com/campaignmanager/accounts" target="_blank">LinkedIn Campaign Manager</a> if there are ads present</li>
        </ul>`
    },{
        isNegative: true,
        comparisonType: "custom",
        title: "LinkedIn Organization Not Tracking",
        altTitle: `LinkedIn Organization`,
        overrideTitle: true,
        icon: `${THEME_DEFAULT.origin}/images/alert-icons/urgent.png`,
        value: "",
        operator: "-",
        comparison: "stopped tracking metrics",
        description: `<p>LinkedIn Organization could have stopped tracking for several reasons</p>
        <ul>
            <li>Token is expired or other credential issues which affects platform connectivity</li>
        </ul>`
    },{
        isNegative: true,
        title: 'Bounce Rate from CPC',
        altTitle: 'Bounce',
        icon: 'https://engine.internetstrategylabs.com/images/alert-icons/bounce-rate.png',
        link: '/traffic-performance',
        value: '16%',
        operator: '-',
        comparison: 'increased',
        altDescription: 'Defined as a single-page session on your site. Classified when a user opens a single page on your site and then exits without triggering any other requests during that session.',
        description: 'Defined as a single-page sessions divided by all sessions, or the percentage of all sessions on your site in which users viewed only a single page and triggered only a single request to the Analytics server.'
    }, {
        isNegative: true,
        comparisonType: 'custom',
        customMessage: 'for the last three consecutive days',
        title: 'Return on Ad Spend (ROAS)',
        altTitle: 'ROAS for the "Ongoing Conversions Promotion https://www.squadronnostalgia.com/" campaign',
        overrideTitle: true,
        icon: 'https://engine.internetstrategylabs.com/images/alert-icons/ROAS.png',
        value: 1.5,
        operator: '-',
        link: '/ads-facebook',
        comparison: 'been equal to or less than',
        description: 'ROAS is calculated by dividing revenue by ad spend.'
    }
  
]

export const alertDictionary = alerts.reduce((prev, curr) => {
    prev[curr.title] = curr
    return prev
}, {})